// extracted by mini-css-extract-plugin
module.exports = {"cta":"headerNewsletter-module--cta--Xo1ld","iconNewsletter":"headerNewsletter-module--iconNewsletter--34nZY"};